export const PRODUCT_ITEMS = [
  { name: 'Insulated Stainless Thermos', description: 'Purchase of Thermos' },
  { name: 'Non-Slip Yoga Mat', description: 'Purchase of Yoga Mats' },
  { name: 'Dimmable LED Lightbulb', description: 'Purchase of Lightbulbs' },
  { name: 'Waterproof Bluetooth Speaker', description: 'Purchase of Speakers' },
  { name: 'Wireless Smart Mouse', description: 'Purchase of Mice' },
  { name: 'Foldable Electric Scooter', description: 'Purchase of Scooters' },
  { name: 'Adjustable Standing Desk', description: 'Purchase of Desks' },
  { name: 'Magnetic Charging Dock', description: 'Purchase of Charging Docks' },
  { name: 'Rechargeable Flashlight', description: 'Purchase of Flashlights' },
  { name: 'Heavy-Duty Resistance Band', description: 'Purchase of Bands' },
  { name: 'Ultralight Camping Stove', description: 'Purchase of Stoves' },
  { name: 'Portable Document Scanner', description: 'Purchase of Scanners' },
  { name: 'Ergonomic Travel Pillow', description: 'Purchase of Pillows' },
  { name: 'Aluminum Laptop Stand', description: 'Purchase of Laptop Stands' },
  { name: 'Assorted Chocolate Box', description: 'Purchase of Chocolate' },
  { name: 'Dry Erase Markers', description: 'Purchase of Markers' },
  { name: 'Stackable Storage Crate', description: 'Purchase of Crates' },
  { name: 'Wall-Mounted Hair Dryer', description: 'Purchase of Hair Dryers' },
  { name: '4K Ultrawide Monitor', description: 'Purchase of Monitors' },
  { name: 'Commercial Espresso Machine', description: 'Purchase of Machines' },
]
